"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "my-5" };
const _hoisted_2 = {
    key: 0,
    class: "block pb-2 font-bold uppercase tracking-wide text-sm"
};
const _hoisted_3 = {
    key: 1,
    class: "block w-full"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "block w-full relative" };
const _hoisted_6 = { class: "relative" };
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("./ShopInput.vue"));
const Alert_vue_1 = __importDefault(require("../Alert.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TagInput',
    props: {
        label: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        modelValue: {
            type: Array,
            default: () => [],
            required: true,
        },
        inputType: {
            type: String,
            default: "text",
            required: false,
        },
    },
    emits: [
        "tagAdded",
        "tagDeleted",
        "reset",
        "update:modelValue",
    ],
    setup(__props, { emit }) {
        const props = __props;
        const newTag = (0, vue_3.ref)("");
        const items = (0, vue_3.ref)(props.modelValue);
        const invalidInputAlert = (0, vue_3.ref)(false);
        const resetTagInput = () => {
            newTag.value = "";
            invalidInputAlert.value = false;
            emit("reset");
        };
        const deleteTag = (tag) => {
            emit("tagDeleted", tag);
            items.value.splice(items.value.indexOf(tag), 1);
            emit("update:modelValue", items);
        };
        const onInputKeyup = (event) => {
            invalidInputAlert.value = false;
            if (event.key !== "Enter" || items.value.includes(newTag.value)) {
                return;
            }
            if (event.target instanceof HTMLInputElement &&
                !event.target.checkValidity()) {
                invalidInputAlert.value = true;
                return;
            }
            items.value.push(newTag.value);
            emit("tagAdded", newTag.value);
            emit("update:modelValue", items);
            resetTagInput();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (__props.label)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)(__props.label), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (items.value.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(items.value, (item) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: item,
                                class: "p-2 mr-2 mb-2 bg-gray rounded inline-block"
                            }, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item) + " ", 1),
                                (0, vue_2.createElementVNode)("i", {
                                    class: "marso-icon-remove cursor-pointer",
                                    onClick: ($event) => (deleteTag(item))
                                }, null, 8, _hoisted_4)
                            ]));
                        }), 128))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            modelValue: newTag.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newTag).value = $event)),
                            placeholder: __props.placeholder,
                            border: "",
                            type: __props.inputType,
                            onKeyup: onInputKeyup
                        }, null, 8, ["modelValue", "placeholder", "type"]),
                        (invalidInputAlert.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                message: _ctx.$trans('invalid_input', 'Invalid input', 'tag_input'),
                                variant: "danger",
                                class: "rounded-t-none",
                                icon: "",
                                "icon-class": "marso-icon-exclamation-triangle"
                            }, null, 8, ["message"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ])
            ]));
        };
    }
});
